import { CancelSMSAddOnService } from './services/CancelSMSAddOnService';
import type { Init } from './types';
import { managerHelpers } from '../../helpers';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import { WithApi } from '../WithApi';

export type AddOnsSubscriptionData = MergedDataReturnType<[CancelSMSAddOnService]>;

export type AddOnsSubscriptionHandlers = MergedHandlersReturnType<[CancelSMSAddOnService]>;

type TApi = ReturnType<CancelSMSAddOnService['api']>;

export class AddOnsSubscriptionManager extends WithApi<TApi> {
  public addOnsSubscriptionInit = ({ queries, mutations, isSingleBillChildAccount }: Init) => {
    const [SMSEntitlementQuery] = queries;
    const [cancelAddOnSubscriptionMutation] = mutations;

    const pending = SMSEntitlementQuery.isPending;
    const { error } = SMSEntitlementQuery;

    if (pending) {
      return {
        status: 'pending',
        data: null,
        handlers: null,
      } as const;
    }

    if (error) {
      return {
        status: 'error',
        data: error,
        handlers: {
          retry: () => {
            managerHelpers.retryQueries(queries);
          },
        },
      } as const;
    }

    const cancelSMSAddOn = new CancelSMSAddOnService(
      SMSEntitlementQuery.data,
      cancelAddOnSubscriptionMutation,
      isSingleBillChildAccount
    );

    this.initApi({
      ...cancelSMSAddOn.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...cancelSMSAddOn.data(),
        error,
      },
      handlers: {
        ...cancelSMSAddOn.handlers(),
        retry: () => {
          managerHelpers.retryQueries(queries);
        },
      },
    } as const;
  };
}
